(() => {
  function init() {
    const strap = document.querySelector('.hero-strap');
    const footer = document.querySelector('footer');
    if (!strap || !footer) return;

    if (strap.__io) strap.__io.disconnect();

    strap.__io = new IntersectionObserver((entries) => {
      strap.style.opacity = entries[0].isIntersecting ? '0' : '1';
    }, { threshold: 0.01 });

    strap.__io.observe(footer);
  }

  window.addEventListener('load', init);
  document.addEventListener('DOMContentLoaded', init);

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', init);
})();
